import React, { useEffect, useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import Message from '../../../Common/Message';
import CTextBox from '../../../Common/CTextBox';
import { Dropdown, Toggle } from '@fluentui/react';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import List from '../../../Templates/List';
import CValidator from '../../../Common/CValidator';
import ListPagination from '../../../Templates/List/ListPagination';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { useGetSectionClassList } from '../../../../hooks/services/sBook/useOfSection';
import CLabel from '../../../Common/CLabel';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../common/Helpers';

const SidePanelSections = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_SetterSelectedItems = props.setterSelectedItems;
    const inputParam_MainSectionList = !isNullUndefined(props.mainSectionList) ? props.mainSectionList : [];
    
    const inputParam_BookId = props.bookId;
    const inputParam_Book = props.objBook;
    const inputParam_SectionClassList = props.sectionClassList;
    
    //const inputParam_PartyId = props.partyId;
    //const inputParam_PartyType = props.partyType;

    //const inputParam_SetterSelectedUserIdList = props.setterSelectedUserIdList;
       
    const buttonAddStyles = { root: { float: "right" } };

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    const [itemIsEditing, setItemIsEditing] = useState(false);
    const [itemEditingId, setItemEditingId] = useState(null);

    const [txtSectionNameIsInValid, setTxtSectionNameIsInValid] = useState(false);
    const [txtSectionCodeIsInValid, setTxtSectionCodeIsInValid] = useState(false);
    const [ddlSectionClassIsInValid, setDdlSectionClassIsInValid] = useState(false);
    const [isInvalidList, setIsInvalidList] = useState(false);
    
    const [tglRequiersApprovalValue, setTglRequiersApprovalValue] = useState(false);
    const [objSectionList, setObjSectionList] = useState({fireUpdate: true, data: inputParam_MainSectionList.length > 0 ? inputParam_MainSectionList :  [], pageNumber: 1, pageSize: 1000, filters: []});

    const [selectedSectionClass, setSelectedSectionClass] = useState(0);


    const [objSection, setObjSection] = useState({
        id: 0,
        bookId: inputParam_BookId,
        sectionNemo: "",
        sectionCode: " ",
        name: "",
        requiresApproval: null,
        userCounts: 0
    });
    const validateForm = (obj) => {
        const validName = obj.name !== "";
        const validCode = obj.sectionCode !== "";
        setTxtSectionNameIsInValid(!validName)
        setTxtSectionCodeIsInValid(!validCode)

        let validClass = true;
        if (inputParam_Book.hasMilestone === true) {
            validClass = selectedSectionClass !== 0;
            setDdlSectionClassIsInValid(!validClass)
        }

        return validName && validCode && validClass;
    };
    const setSectionNameValue = (value) => {
        setTxtSectionNameIsInValid(value==="");
        setObjSection(prevState => ({ ...prevState, name: value }));
        setShowMessage(false);
    };
    const setSectionCodeValue = (value) => {
        setTxtSectionCodeIsInValid(value==="");
        setObjSection(prevState => ({ ...prevState, sectionCode: value }));
        setShowMessage(false);
    };

    
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setObjSectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: []
        }));
        setObjSection({
            id: 0,
            bookId: inputParam_BookId,
            sectionNemo: "",
            sectionCode: " ",
            name: "",
            requiresApproval: null,
            userCounts: 0
        });
        setShowMessage(false);
        setTxtSectionNameIsInValid(false)
        setTxtSectionCodeIsInValid(false)
        setTglRequiersApprovalValue(false);
        setIsInvalidList(false)
    };

    const onEditSectionToList = () => {
        const _isValidForm = validateForm(objSection);

        if (_isValidForm) {
            let aux_objSectionList = [...objSectionList.data];
            objSection.id = itemEditingId;
            objSection.requiresApproval = tglRequiersApprovalValue;
            objSection.sectionClassId = selectedSectionClass;

            if (objSectionList.data.length === 0) {
                objSectionList.data.push(objSection)
            }
            else {
                const duplicatedSection = objSectionList.data.find(x => x.name === objSection.name && x.id !== itemEditingId);

                if (isNullUndefined(duplicatedSection)) {
                    aux_objSectionList.forEach(element => {
                        if (itemEditingId === element.id) {
                            element.name = objSection.name;
                            element.requiresApproval = objSection.requiresApproval;
                            element.sectionClassId = objSection.sectionClassId;
                            element.sectionCode = objSection.sectionCode;
                        }
                    });                 
                }
                else {
                    setMessage(t('data-lang-msg-duplicatedsection'));
                    setMessageType("error");
                    setShowMessage(true);

                    return;
                }
            }

            setObjSectionList(prevState => ({
                ...prevState,
                data: aux_objSectionList,
                fireUpdate: true
            }));
            setObjSection({
                id: 0,
                bookId: inputParam_BookId,
                sectionNemo: "",
                sectionCode: " ",
                name: "",
                requiresApproval: null,
                userCounts: 0
            });

            setIsInvalidList(false);
            setTxtSectionNameIsInValid(false);
            setTxtSectionCodeIsInValid(false);
            setItemIsEditing(false);
            setItemEditingId(null);
        }
        else {
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning")
            setShowMessage(true);
        }
    }

    const onAddSectionToList = () => {
        const _isValidForm = validateForm(objSection);

        if (_isValidForm) {
            objSection.requiresApproval = tglRequiersApprovalValue;
            objSection.sectionClassId = selectedSectionClass;

            if (objSectionList.data.length === 0) {
                objSectionList.data.push(objSection)
            }
            else {
                const duplicatedSection = objSectionList.data.find(x => x.name === objSection.name);

                if (duplicatedSection === null || duplicatedSection === undefined) {
                    const _lowerId = objSectionList.data.length !== 0 ? objSectionList.data.reduce((min, obj) => obj.id < min ? obj.id : min, objSectionList.data[0].id) : 0;
                    objSection.id = (_lowerId > 0 ? 0 : _lowerId) -1;
                    objSectionList.data.push(objSection)                    
                }
                else {
                    setMessage(t('data-lang-msg-duplicatedsection'))
                    setMessageType("error")
                    setShowMessage(true);

                    return;
                }
            }


            setObjSectionList(prevState => ({
                ...prevState,
                data: objSectionList.data,
                fireUpdate: true
            }));
            setObjSection({
                id: 0,
                bookId: inputParam_BookId,
                sectionNemo: "",
                sectionCode: " ",
                name: "",
                requiresApproval: null,
                userCounts: 0
            });

            setIsInvalidList(false);
            setTxtSectionNameIsInValid(false)
            setTxtSectionCodeIsInValid(false)
        }
        else {
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning")
            setShowMessage(true);
        }
    };

    const onAddSectionToBox = () => {
        const _isValidForm = objSectionList.data.length > 0;

        if (_isValidForm) {
            //Enviar a guardar.
            inputParam_SetterSelectedItems(objSectionList.data);
            onDismissPanel();
        }
        else {
            setMessage(t('data-lang-msg-requireddatanotset'))
            setMessageType("warning")
            setShowMessage(true);
        }

        setIsInvalidList(!_isValidForm)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    const onDeleteSectionFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };
    const onEditSectionFromListClick = (item) => {
        setSectionNameValue(item.name);
        setSectionCodeValue(item.sectionCode);
        setTglRequiersApprovalValue(item.requiresApproval);
        setSelectedSectionClass(item.sectionClassId);
        setItemIsEditing(true);
        setItemEditingId(item.id);
    };
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRequiresApprovalChange = (e, checked) => {
        setTglRequiersApprovalValue(checked);
    };
    
    const handleDropdownSectionClassChange = (event, option) => {
        setSelectedSectionClass(option.key);
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="sectionsCreation"
                            data={ objSectionList }
                            setData={ setObjSectionList } />
                    </Col>
                    <Col xl={12}>
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={messageType} setterShowMessage={ setShowMessage } />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={ onAddSectionToBox } styles={ _global_buttonStyles }>{ t('data-lang-btn-acept') }</PrimaryButton>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    //#CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newList = [];

        objSectionList.data.forEach(obj => {
            if (obj.id !== itemToDelete.id) {
                newList.push(obj)
            }
        })

        setObjSectionList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newList
        }));

        setItemToDelete(null);
    }

    useEffect(() => { 
        if (inputParam_MainSectionList.length > 0) {
            setObjSectionList({fireUpdate: true, data: inputParam_MainSectionList, pageNumber: 1, pageSize: 1000, filters: []})
        }
    }, [inputParam_MainSectionList]);


    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-createsection') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col xl={6}>
                        <CLabel labelText={ t('data-lang-lbl-sectionclass') } /><br/>
                        {
                            inputParam_SectionClassList &&
                            <>
                                <Dropdown
                                    selectedKey={selectedSectionClass}
                                    options={inputParam_SectionClassList}
                                    onChange={handleDropdownSectionClassChange}
                                    styles={{ dropdown: { width: '150px', border: (ddlSectionClassIsInValid ? '1px solid #a4262c !important' : undefined) } }}
                                />
                                <CValidator isInValid={ddlSectionClassIsInValid} inValidText={t('data-lang-lbl-required')} />
                            </>
                        }
                    </Col>
                    <Col xl={6}>
                        <CLabel labelText={ t('data-lang-lbl-requiresapproval') } /><br/>
                        <Toggle
                            checked={ tglRequiersApprovalValue }
                            onChange={ onRequiresApprovalChange }
                            role="checkbox"
                            onText={ t('data-lang-btn-yesrequired') }
                            offText={ t('data-lang-btn-norequired') }
                            styles={ {root:{float: "left", display: "flex"}, container: 'paddingTop: 5px', label: {marginRight : "5px"}} }
                        />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <CTextBox controlValue={ objSection.name } setterControlValue={ setSectionNameValue } isInValid={txtSectionNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-name') } />
                    </Col>
                    <Col>
                        <CTextBox editMode={ false } controlValue={ objSection.sectionCode } setterControlValue={ setSectionCodeValue } isInValid={txtSectionCodeIsInValid} textBoxName="code" labelText={ t('data-lang-lbl-code') } />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        {
                            itemIsEditing === false &&
                            <PrimaryButton onClick={ onAddSectionToList } styles={ buttonAddStyles }>{ t('data-lang-btn-add') }</PrimaryButton>
                        }
                        {
                            itemIsEditing === true &&
                            <PrimaryButton onClick={ onEditSectionToList } styles={ buttonAddStyles }>{ t('data-lang-btn-edit') }</PrimaryButton>
                        }
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="sectionsCreation"
                            manipulateLocalData={ true }
                            setData={setObjSectionList}
                            className="no-compact-list big-header"
                            data={objSectionList}
                            columns={[
                                {
                                    key: 'name',
                                    name: t('data-lang-lbl-section'),
                                    fieldName: 'name',
                                    minWidth: 400,
                                    maxWidth: 400,
                                    onRender:(item) => {
                                        const sectionClass = inputParam_SectionClassList.find(x => x.key === item.sectionClassId);
                                        return <div>
                                            <div><b>{t('data-lang-lbl-code') }</b>&nbsp;:&nbsp;{ item.sectionCode }</div>
                                            <div><b>{t('data-lang-lbl-sectionname') }</b>&nbsp;:&nbsp;{ item.name }</div>
                                            <div><b>{t('data-lang-lbl-sectionclass') }</b>&nbsp;:&nbsp;{ !isNullUndefinedOrEmpty(sectionClass) ? sectionClass.text : t('data-lang-lbl-nodataselected') }</div>
                                            <div><b>{t('data-lang-lbl-requiresapproval') }</b>&nbsp;:&nbsp;{ item.requiresApproval ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') }</div>
                                        </div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    onRender:(item, row) => {
                                        return <div>
                                                <OverflowSet
                                                    className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                    role="menubar"
                                                    items={[
                                                        {
                                                            key: 'item1',
                                                            icon: 'Edit',
                                                            name: t('data-lang-btn-edit'),
                                                            title: t('data-lang-btn-edit'),
                                                            onClick: () => onEditSectionFromListClick(item),
                                                        },
                                                        {
                                                            key: 'item2',
                                                            icon: 'Delete',
                                                            name: t('data-lang-btn-delete'),
                                                            title: t('data-lang-btn-delete'),
                                                            onClick: () => onDeleteSectionFromListClick(item, setItemToDelete),
                                                        }
                                                    ]}
                                                    onRenderOverflowButton={__onRenderOverflowButton}
                                                    onRenderItem={__onRenderOverflowItem}
                                                />
                                        </div>
                                    }
                                }
                            ]}
                        />
                        <CValidator isInValid={isInvalidList} />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-boxname-warning'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 950 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelSections;